import { cn } from 'twyne-new.ui'

import { useView } from '@/modules/cms/views/post/components/builder/context'
import useSelectedProperties from '@/modules/cms/views/post/components/builder/hooks/useSelectedProperties'

import Sidebar from '../Sidebar'
import { OVERLAY_TRANSITION, floatingPlacement } from '../sidebarLayout'

import Properties from './Properties'

export default function RightSidebar() {
  const { value: view } = useView()
  const hasProperties = Boolean(useSelectedProperties())

  const collapsed = view !== 'builder' || !hasProperties

  return <Sidebar
    size='112'
    open={true}
    className={cn('absolute h-auto z-30', OVERLAY_TRANSITION, collapsed && 'pointer-events-none')}
    style={floatingPlacement('right', collapsed)}
  >
    <Properties />
  </Sidebar>
}
